/**
 * The one event the engine owns (`specs/M6-A1-automation-engine.md` §5.2).
 *
 * It is deliberately **not** in `packages/shared/src/events.ts`'s `EVENT_TYPES`: that list is the
 * realtime outbox vocabulary the browser subscribes to, and a schedule tick has no client-side
 * patch. The scheduler hands this event straight to the engine, so it never becomes an outbox
 * row and never reaches a Socket.IO room.
 */
export const AUTOMATION_SCHEDULE_DUE = 'automation.schedule.due';
//# sourceMappingURL=events.js.map